import React, { useState } from 'react';
import { Container, Paper, Tabs, Tab, Box, Typography } from '@mui/material';
import Layout from '../components/Layout';
import ManifestLogs from '../components/ManifestLogs';
import ManifestSuccessfulSends from '../components/ManifestSuccessfulSends';
import GuideEmails from '../components/GuideEmails';

const Manifest = () => {
  const [tabValue, setTabValue] = useState(1);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Layout>
      <Container maxWidth={false} sx={{ width: '100%' }}>
        <Typography variant="h4" gutterBottom fontWeight={700} sx={{ mb: 2 }}>
          Manifest
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
            <Tab label="Logs" />
            <Tab label="Successful Sends" />
            <Tab label="Guide Emails" />
          </Tabs>
          <Box>
            {tabValue === 0 && <ManifestLogs />}
            {tabValue === 1 && <ManifestSuccessfulSends />}
            {tabValue === 2 && <GuideEmails />}
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default Manifest;

